// Extracted from `pages/CustomerDetailPage.js` (P2 refactor step 4b).
// Tab "Oportunidades" — 1:1 move del JSX. Muestra oportunidades activas,
// ganadas y perdidas del cliente.
import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { TrendingUp, Plus, DollarSign } from "lucide-react";

export const OportunidadesTab = ({
  opportunities,
  formatCurrency,
  navigate,
}) => {
  return (
    <Card className="bg-[#0A0A35] border-[#1E1E5F]">
      <CardHeader>
        <CardTitle className="text-white font-heading flex items-center gap-2">
          <TrendingUp className="h-5 w-5 text-[#03BEE4]" />
          Oportunidades de Venta
        </CardTitle>
        <CardDescription className="text-slate-400">
          Leads y oportunidades comerciales asociadas a este cliente
        </CardDescription>
      </CardHeader>
      <CardContent>
        {opportunities.length === 0 ? (
          <div className="text-center py-8">
            <TrendingUp className="h-12 w-12 text-slate-500 mx-auto mb-4" />
            <p className="text-slate-400">No hay oportunidades registradas</p>
            <Button
              className="mt-4 bg-[#42E695] text-[#04042C]"
              onClick={() => navigate("/pipeline")}
            >
              <Plus className="h-4 w-4 mr-2" />
              Crear Oportunidad
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            {/* Active Opportunities */}
            {opportunities.filter(o => !["GANADA", "PERDIDA"].includes(o.stage)).length > 0 && (
              <div>
                <h4 className="text-[#03BEE4] font-medium mb-3">Oportunidades Activas</h4>
                <div className="space-y-3">
                  {opportunities
                    .filter(o => !["GANADA", "PERDIDA"].includes(o.stage))
                    .map((opp) => (
                      <div
                        key={opp.id}
                        className="p-4 rounded-lg bg-[#1B1B4B]/50 border border-[#1E1E5F] hover:border-[#03BEE4]/50 transition-all"
                      >
                        <div className="flex items-start justify-between">
                          <div>
                            <p className="text-xs text-slate-400 font-mono">{opp.opportunity_id}</p>
                            <h5 className="text-white font-medium mt-1">{opp.title}</h5>
                          </div>
                          <Badge className={`
                            ${opp.stage === "LEAD" ? "bg-slate-500" : ""}
                            ${opp.stage === "CONTACTADO" ? "bg-[#03BEE4]" : ""}
                            ${opp.stage === "PROPUESTA" ? "bg-yellow-500" : ""}
                            ${opp.stage === "NEGOCIACION" ? "bg-purple-500" : ""}
                            text-white
                          `}>
                            {opp.stage}
                          </Badge>
                        </div>
                        <div className="flex items-center gap-4 mt-3 text-sm">
                          <div className="flex items-center gap-1 text-[#42E695]">
                            <DollarSign className="h-4 w-4" />
                            {formatCurrency(opp.estimated_mrr)}/mes
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}

            {/* Won Opportunities */}
            {opportunities.filter(o => o.stage === "GANADA").length > 0 && (
              <div className="mt-6">
                <h4 className="text-[#42E695] font-medium mb-3">Oportunidades Ganadas</h4>
                <div className="space-y-3">
                  {opportunities
                    .filter(o => o.stage === "GANADA")
                    .map((opp) => (
                      <div
                        key={opp.id}
                        className="p-4 rounded-lg bg-[#42E695]/10 border border-[#42E695]/30"
                      >
                        <div className="flex items-start justify-between">
                          <div>
                            <p className="text-xs text-slate-400 font-mono">{opp.opportunity_id}</p>
                            <h5 className="text-white font-medium mt-1">{opp.title}</h5>
                          </div>
                          <Badge className="bg-[#42E695] text-white">
                            GANADA
                          </Badge>
                        </div>
                        <div className="flex items-center gap-1 mt-3 text-[#42E695] text-sm">
                          <DollarSign className="h-4 w-4" />
                          {formatCurrency(opp.estimated_mrr)}/mes
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}

            {/* Lost Opportunities */}
            {opportunities.filter(o => o.stage === "PERDIDA").length > 0 && (
              <div className="mt-6">
                <h4 className="text-red-400 font-medium mb-3">Oportunidades Perdidas</h4>
                <div className="space-y-3">
                  {opportunities
                    .filter(o => o.stage === "PERDIDA")
                    .map((opp) => (
                      <div
                        key={opp.id}
                        className="p-4 rounded-lg bg-red-500/10 border border-red-500/30"
                      >
                        <div className="flex items-start justify-between">
                          <div>
                            <p className="text-xs text-slate-400 font-mono">{opp.opportunity_id}</p>
                            <h5 className="text-slate-300 font-medium mt-1">{opp.title}</h5>
                          </div>
                          <Badge className="bg-red-500 text-white">
                            PERDIDA
                          </Badge>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
